// extracted by mini-css-extract-plugin
export default {"caption":"LopListContainer_caption__xtFSx","container":"LopListContainer_container__LdS0M","actions":"LopListContainer_actions__fX600","space":"LopListContainer_space__ALdIg"};